import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';

const EditSection = () => {
  const [lectureData, setLectureData] = useState([
    {
      title: '',
      overview: '',
      video_url: '',
    },
  ]);
  const [sectionId, setSectionId] = useState('');

  const handleChange = (e) => {
    setLectureData({ ...lectureData, [e.target.name]: e.target.value });
  };

  const { id } = useParams();
  let history = useHistory();
  const btnStyle = {
    background: '#ffcc29',
    color: '#fff',
    border: 'none',
  };
  const uname = JSON.parse(localStorage.getItem('uname'));
  const AuthStr = process.env.REACT_APP_AUTH_STR;
  let fetchUrl = `https://stucharge.bakersbrisk.com/api/lectureapi?username=${uname}&id=${id}`;
  let URL = `https://stucharge.bakersbrisk.com/api/lectureapi?username=${uname}&id=${id}`;

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(fetchUrl, {
        headers: { Authorization: AuthStr },
      });
      if (result.status === 200) {
        setSectionId(result.data.section);
        setLectureData(result.data);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var bodyFormData = new FormData();
  const submitHandler = (e) => {
    e.preventDefault();
    // Fire confirmation
    Swal.fire({
      title: 'Are you sure?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed || !result.isConfirmed) {
        updateClass();
      } else if (result.isDenied) {
        Swal.fire('Lecture not updated!', '', 'info');
      }
    });
  };

  async function updateClass() {
    bodyFormData.append('title', lectureData.title);
    bodyFormData.append('overview', lectureData.overview);
    bodyFormData.append('video_url', lectureData.video_url);
    bodyFormData.append('section_id', sectionId);
    const requestOptions = {
      method: 'PUT',
      headers: { Authorization: AuthStr },
      body: bodyFormData,
    };
    fetch(URL, requestOptions)
      .then(async (response) => {
        const data = await response.json();
        // check for error response
        if (!response.ok) {
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        Swal.fire('Lecture updated successfully!', '', 'success').then(
          (result) => {
            if (result.isConfirmed || !result.isConfirmed) {
              history.push('/courses/section');
              history.push(`/courses/section/${sectionId}`);
            }
          }
        );
      })
      .catch((error) => {
        Swal.fire('Error updating data', '', 'error');
      });
  }

  return (
    <div className='main_container'>
      <div className='alert-heading'>
        <h1>Update Class Details</h1>
      </div>
      <form onSubmit={(e) => submitHandler(e)} className='class-form'>
        <div className='form-control'>
          <label htmlFor='title'>Title</label>
          <input
            type='text'
            value={lectureData.title || ''}
            required
            name='title'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='overview'>Description</label>
          <textarea
            type='text'
            className='update-detail'
            value={lectureData.overview || ''}
            required
            name='overview'
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className='form-control'>
          <label htmlFor='video_url'>URL</label>
          <input
            type='url'
            value={lectureData.video_url || ''}
            required
            name='video_url'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <button type='submit' className='btn' style={btnStyle}>
          Update Lecture
        </button>
      </form>
    </div>
  );
};

export default EditSection;
